import React from 'react';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

/**
 * ExpandButton - Memoized expand/collapse button for completed assignments
 */
function ExpandButton({ eventId, isExpanded, onToggle }) {
  const handleClick = React.useCallback((e) => {
    e.stopPropagation();
    onToggle(eventId);
  }, [eventId, onToggle]);

  return (
    <IconButton
      edge="end"
      size="small"
      onClick={handleClick}
      sx={{ mr: 1, p: 0.5 }}
    >
      {isExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
    </IconButton>
  );
}

export default React.memo(ExpandButton);
